module.exports = __webpack_public_path__ + "img/LOGO APOSTAR-06.6972847b.png";